export default "__VITE_ASSET__BS8br8bm__"